// extracted by mini-css-extract-plugin
module.exports = {"donation":"lW","donationIcon":"lX","donationTitle":"lY"};